import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e30d090c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WTopBar})
